export const _visioMimeTypes = [
  "application/vnd.visio2013",
  "application/vnd.visio",
  'application/vnd.visio; version="2000"',
  'application/vnd.visio; version="2002"',
  'application/vnd.visio; version="2003-2010"',
  'application/vnd.visio; version="5.0"',
];
